import * as React from "react";
import type { TypeCharacterCounterProps } from "./CharacterCounterTypes";
import CharacterCounterHybrid from "./CharacterCounterHybrid";

/**
 * CharacterCounter component. Automatically routes between the Tailwind
 * implementation (preferred) and the styled-components implementation (for
 * consumers using system props or a styled() extension).
 */
export const CharacterCounter = React.forwardRef<
  HTMLDivElement,
  TypeCharacterCounterProps
>((props, ref) => <CharacterCounterHybrid {...props} ref={ref} />);

CharacterCounter.displayName = "CharacterCounter";
